import React, { forwardRef } from 'react'

import { cn } from 'utils'
import { mergeRefs } from 'utils/ref_utils'

import { useClearableState } from './hooks/useClearableState'
import { SolidCircleCheckIcon } from './icons/SolidCircleCheck'
import { ClearButton, TextLikeFormField, type TextLikeFormFieldProps } from './TextLikeFormField'

export interface TextInputProps extends Omit<TextLikeFormFieldProps, 'className' | 'children'>, React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  placeholder?: string;
  validated?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
  validated,
  ...props
}, forwardedRef) => {
  const { clearValue, handleChange, ref, isClearable } = useClearableState(
    props.defaultValue,
    props.value,
    props.onChange
  )

  return (
    <TextLikeFormField {...props}>
      {(formFieldProps) => (
        <>
          <input
            {...formFieldProps}
            className={cn(formFieldProps.className, {
              'pr-2 group-hover/field:pr-7 group-focus-within/field:pr-7':
                isClearable && !validated,
              'pr-7 group-hover/field:pr-12 group-focus-within/field:pr-12':
                isClearable && validated,
            })}
            onChange={handleChange}
            ref={mergeRefs(ref, forwardedRef)}
            type='text'
          />
          {!props.disabled && (isClearable || validated) && (
            <div className='flex items-center absolute right-1 top-0 bottom-0'>
              {isClearable && <ClearButton onClick={clearValue} />}
              {validated && (
                <span className='pointer-events-none text-green-400 pr-1'>
                  <SolidCircleCheckIcon size={16} />
                </span>
              )}
            </div>
          )}
        </>
      )}
    </TextLikeFormField>
  )
})
